// 日报管理
import axios from '@/libs/api.request'
import qs from 'qs'

// 获取组织列表（部门）
export const getOrgList = () => {
  return axios.request({
    url: '/api/hr/org/getOrgList',
    method: 'post'
  })
}

// 查询岗位列表
export const selectPositionList = (data) => {
  return axios.request({
    url: '/api/hr/positionAndRank/selectPositionList',
    data,
    method: 'post'
  })
}

export const getMenuTreetByUser = (data) => {
  return axios.request({
    url: '/api/sys/getMenuTreetByUser',
    data,
    method: 'post'
  })
}
// 更新站内信消息为已读(ALL)
export const updateAllUnRead = (data) => {
  return axios.request({
    url: '/api/stationLetter/updateAllUnRead',
    data,
    method: 'post'
  })
}
// 根据手机号获取用户及租户信息
export const getUserTenantByMobile = (data) => {
  return axios.request({
    url: '/api/hr/user/getUserTenantByMobile',
    data,
    method: 'post'
  })
}
// 获取租户信息
export const queryCurrentTenant = (data) => {
  return axios.request({
    url: '/api/tenant/queryCurrentTenant',
    data,
    method: 'post'
  })
}

// 通过预授权码预览图片
export const previewByPresignedCode = (data) => {
  return axios.request({
    url: '/api/doc/previewByPresignedCode?code=' + data,
    method: 'post',
    responseType: 'blob'
  })
}

// 获取多个字典类型的下拉框选项的接口
export const getDictMapByDicTypeList = (data) => {
  return axios.request({
    url: '/api/api/getDictMapByDicTypeList',
    method: 'post',
    data
  })
}

// 获取字典类型的下拉框选项的接口
export const getDictListByDicType = (data) => {
  return axios.request({
    url: '/api/api/getDictListByDicType',
    method: 'post',
    data
  })
}

// 根据parentCode获取行政区划tree
export const selectRegionTreeByParentCode = (data) => {
  return axios.request({
    url: '/api/sys/selectRegionTreeByParentCode',
    method: 'post',
    data
  })
}

// 获取文件地址
export const previewUrl = (data) => {
  return axios.request({
    url: '/api/api/previewUrl',
    method: 'post',
    data
  })
}
// 获取文件地址

export const previewUrl2 = (data) => {
  return axios.request({
    data: qs.stringify(data),
    url: '/api/api/previewUrl2',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    }
  })
}
// 获取文件地址list
export const previewUrls = (data = []) => {
  return axios.request({
    url: '/api/api/previewUrls',
    method: 'post',
    data
  })
}

// 获取文件地址list
export const fileUpload = (data = []) => {
  return axios.request({
    url: '/api/api/fileUpload',
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    data
  })
}
